<div class="mat-elevation-z8">
  <div class="filter-actions-line">
    @if(controlPermissions.addButton){
      <button mat-raised-button color="primary" (click)="openHaulerForm(true)" data-testId="btnAddSite">
        <mat-icon>add</mat-icon>
        <span>Add Hauler</span>
      </button>
    }
    <div class="custom-search-box">
      <mat-icon>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" [value]="filterText" placeholder="Filter Haulers..." data-testId="btnSearch" />
    </div>
  </div>
</div>
<div class="market-container mat-elevation-z8 mar-top-20">
  <mat-card>
    <mat-card-content>
      <div class="gridheight mat-elevation-z8 viewport table-container">
        <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows matSort>
          <ng-container matColumnDef="expandIcon">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" style="
                width: 32px;
                border-right: 1px solid currentColor;
                padding-right: 24px;
                text-align: center;
              "></td>
          </ng-container>
          <ng-container matColumnDef="hid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Actions
            </th>
            <td mat-cell *matCellDef="let element">{{ element.hid }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="mat-header-row actionwidth">
              Actions
            </th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openContextmenu(row, 'EDIT')">
                <mat-icon>edit</mat-icon>
              </button>
              @if(controlPermissions.delete){
                <button mat-icon-button type="button" color="warn" title="Delete" (click)="openContextmenu(row, 'DELETE')" style="color: red;">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>

          </ng-container>

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Hauler ID
            </th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Hauler Name
            </th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>
          <ng-container matColumnDef="contactName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Contact Name
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.contactName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contactEmail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Email
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.contactEmail }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contactPhone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Phone
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.contactPhone }}
            </td>
          </ng-container>
          <ng-container matColumnDef="addressLine1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Address Line 1
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.addressLine1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="addressLine2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Address Line 2
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.addressLine2 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              State
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.state }}
            </td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              City
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.city }}
            </td>
            onDeleteDocument
          </ng-container>
          <ng-container matColumnDef="zipCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Zip
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.zipCode }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length"
                style="color: red; text-align: center; font-weight: 500">
              No data matching the filter.
            </td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
